// Build glow-facing URLs from build-time config. This is the THIRD consumer of
// the scheme + base-domain fact single-sourced server-side in
// internal/glowhost (auth-api's handoff host + glow-api's preview_url are the
// other two). The defaults below MUST match glowhost.DefaultScheme /
// DefaultBaseDomain ('https' / 'backlit.run') so prod agrees by construction;
// the *.backlitdev.run acceptance build sets VITE_GLOW_BASE_DOMAIN=backlitdev.run
// + VITE_GLOW_URL_SCHEME=https, which MUST equal the GLOW_BASE_DOMAIN /
// GLOW_URL_SCHEME the services are deployed with (both wired from Terraform
// var.domain — CLAUDE.md §12; cross-boundary-audit Slice 7).
const BASE_DOMAIN =
  (import.meta.env.VITE_GLOW_BASE_DOMAIN as string | undefined) ?? 'backlit.run'
const SCHEME =
  (import.meta.env.VITE_GLOW_URL_SCHEME as string | undefined) ?? 'https'

/** The glow's display host, e.g. "my-glow.backlit.run". */
export function glowHost(name: string): string {
  return `${name}.${BASE_DOMAIN}`
}

/** The glow's live root URL, e.g. "https://my-glow.backlit.run". */
export function glowUrl(name: string): string {
  return `${SCHEME}://${glowHost(name)}`
}

/** A version's immutable preview URL, e.g. ".../_v/{ver}/". */
export function glowVersionUrl(name: string, versionID: string): string {
  return `${glowUrl(name)}/_v/${versionID}/`
}
